import { camelCase } from '../util.js'

const works = [
  {
    title: 'tt-品牌KV-coffee time（横版）',
    desc: 'tt-品牌KV-coffee time（横版）',
    thumb: camelCase('cases-brand-tommee-0'),
    zpic: [
      camelCase('cases-brand-tommee-lazyload-01')
    ]
  },
  {
    title: 'tt-品牌KV-画家妈妈篇',
    desc: 'tt-品牌KV-画家妈妈篇',
    thumb: camelCase('cases-brand-tommee-1'),
    zpic: [
      camelCase('cases-brand-tommee-lazyload-11')
    ]
  },
  {
    title: 'tt-2019 KV横版二胎篇0510-FA',
    desc: 'tt-2019 KV横版二胎篇0510-FA',
    thumb: camelCase('cases-brand-tommee-2'),
    zpic: [
      camelCase('cases-brand-tommee-lazyload-21')
    ]
  },
  {
    title: 'tt-品牌KV-living room （横版）',
    desc: 'tt-品牌KV-living room （横版）',
    thumb: camelCase('cases-brand-tommee-3'),
    zpic: [
      camelCase('cases-brand-tommee-lazyload-31')
    ]
  },
  {
    title: 'tt-品牌KV-建筑师爸爸篇',
    desc: 'tt-品牌KV-建筑师爸爸篇',
    thumb: camelCase('cases-brand-tommee-4'),
    zpic: [
      camelCase('cases-brand-tommee-lazyload-41')
    ]
  },
  {
    title: 'tt-品牌KV-建筑师爸爸篇',
    desc: 'tt-品牌KV-建筑师爸爸篇',
    thumb: camelCase('cases-brand-tommee-5'),
    zpic: [
      camelCase('cases-brand-tommee-lazyload-51')
    ]
  },
  {
    title: 'tt-品牌KV-office lady（横版）',
    desc: 'tt-品牌KV-office lady（横版）',
    thumb: camelCase('cases-brand-tommee-6'),
    zpic: [
      camelCase('cases-brand-tommee-lazyload-61')
    ]
  },
  {
    title: 'tt-品牌KV-宇航员篇',
    desc: 'tt-品牌KV-宇航员篇',
    thumb: camelCase('cases-brand-tommee-7'),
    zpic: [
      camelCase('cases-brand-tommee-lazyload-71')
    ]
  },
  {
    title: 'tt-品牌视频60s-0510',
    desc: 'tt-品牌视频60s-0510',
    thumb: camelCase('cases-brand-tommee-8'),
    zpic: [
      require('../../assets/cases-brand-tommee-lazyload-81.mp4')
    ]
  },
  {
    title: 'tt-品牌视频（2017）',
    desc: 'tt-品牌视频（2017）',
    thumb: camelCase('cases-brand-tommee-9'),
    zpic: [
      require('../../assets/cases-brand-tommee-lazyload-91.mp4')
    ]
  },
  {
    title: 'tt-品牌视频（2018）',
    desc: 'tt-品牌视频（2018）',
    thumb: camelCase('cases-brand-tommee-10'),
    zpic: [
      require('../../assets/cases-brand-tommee-lazyload-101.mp4')
    ]
  },
  {
    title: 'tt-CTN进化论产品视频FA（2017）',
    desc: 'tt-CTN进化论产品视频FA（2017）',
    thumb: camelCase('cases-brand-tommee-11'),
    zpic: [
      require('../../assets/cases-brand-tommee-lazyload-111.mp4')
    ]
  },
  {
    title: 'tt-ENG产品病毒视频',
    desc: 'tt-ENG产品病毒视频',
    thumb: camelCase('cases-brand-tommee-12'),
    zpic: [
      require('../../assets/cases-brand-tommee-lazyload-121.mp4')
    ]
  }
]
export default {
  name: '汤美星',
  logo: {
    default: camelCase('cases-brand-13'),
    active: camelCase('cases-brand-13-cover')
  },
  works
}
